var _style, _defs, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED5565;}\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#4757A9;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40,
    cy: 40,
    r: 40
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,0h97.4c6,0,10.8,4.9,10.8,10.9v58.2c0,6-4.8,10.9-10.8,10.9H10.8C4.8,80,0,75.1,0,69.1V10.9 C0,4.9,4.8,0,10.8,0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    className: "st1",
    width: 13.6,
    height: 80
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    className: "st1",
    width: 119,
    height: 13.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    className: "st2",
    width: 3.4,
    height: 80
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 39.2,
    className: "st2",
    width: 119,
    height: 3.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.e66e77fff578b27ee8291c0657e9fa2f.svg";
export { ForwardRef as ReactComponent };